import { Environment } from './environment.model';

export const environment: Environment = {
  ENV_NAME: 'uat',
  SUPERTOKENS_API_DOMAIN: 'https://uat.novaten.es',
  PWA_PUBLIC_VAPID_KEY: 'BGOTvAit2hCjZmq5ENm33PIHPT2TteeIcmY5LAtBixKo9b2mqp_xBVfqrC1xY0k0KSXFTyVcFqLig-XC08b6gBw',
  PUSH_NOTIFICATIONS_ENABLED: true,
  isDev: false
};
